import React, { Component } from 'react';
import { Col, Row, Container } from 'react-bootstrap';

import '../css/FAQ.css';

class FAQ extends Component {
    constructor(props) {
        super(props)
        this.state = {
            collapsedNames: []
        }
    }

    collapsed(name, collapsedNames) {
        return (collapsedNames.length <= 0 ? false : collapsedNames.includes(name) ? true : false)
    }

    render() {
        return (
            <Container>
                <Row>
                    <Col className="faqContainer">
                        <div><h3>Frequently Asked Questions</h3></div>
                        <details open>
                            <summary>What is Trove?</summary>
                            <div className="faq__content">
                                <p>
                                    Trove is a plugin for Dungeon Helper. You can go check them out on <a href="https://dungeonhelper.com">dungeonhelper.com</a> for more information.
                                </p>
                                <p>
                                    Trove collects information about your inventory and, when you choose, uploads that data to our database. You can then search that database from
                                    any of your characters to find stuff!
                                </p>
                            </div>
                        </details>
                        <details>
                            <summary>How do I use it?</summary>
                            <div className="faq__content">
                                <h5>Installation</h5>
                                <ul>
                                    <li>Download and install <a href="https://dungeonhelper.com/download">Dungeon Helper</a>.</li>
                                    <li>Download Trove from <a href="https://trove.dungeonhelper.com/download">here</a>.</li>
                                    <li>In Dungeon Helper, go to Settings, Add Plugin, and browse to the downloaded Trove zip file. Restart DH, Check the
                                        box next to "Trove", and you're on your way</li>
                                </ul>
                                <h5>Using Trove</h5>
                                <p>
                                    In order to search for inventory, you have to start by uploading your inventory. In order for Trove to find items in your
                                    bank, you must have your bank open (and lagging done). With the bank open, click the "Upload Inventory" button, and in a
                                    few seconds your inventory will be searchable. As you move items around, you will have to re-upload a character in order
                                    for Trove to know about anything that has changed.
                                </p>
                                <p>We hope that searching for items is self explanatory. Hit us up in Discord if it's not.</p>
                            </div>
                        </details>
                        <details>
                            <summary>How much does it cost?</summary>
                            <div className="faq__content">
                                <p>
                                    Trove is a completely free service. If you wish to make a donation, you can do so through PayPal
                                    at the bottom of any page of the <a href="https://dungeonhelper.com">dungeonhelper.com</a> website.
                                </p>
                            </div>
                        </details>
                        <details>
                            <summary>Does using this break the DDO/SSG EULA/ToS?</summary>
                            <div className="faq__content">
                                <p>
                                    Disclaimer: we are not lawyers and cannot offer legal advice. See the <a href="https://dungeonhelper.com">dungeonhelper.com</a> FAQ page for
                                    a longer answer.
                                </p>
                            </div>
                        </details>
                        <details>
                            <summary>What data do you collect?</summary>
                            <div className="faq__content">
                                <p>
                                    We store data about all your items, which server and character they belong to, and a unique hash that
                                    identifies your account. We do not store any account credentials or any personally identifiable information.
                                </p>
                            </div>
                        </details>
                        <details>
                            <summary>How can I contact the people that made this?</summary>
                            <div className="faq__content">
                                <p>
                                    Join our <a href="https://discord.gg/bfMZnbz">discord</a> - we're quite chatty and happy to talk to our users.
                                </p>
                            </div>
                        </details>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default FAQ;